module.exports = __webpack_public_path__ + "img/NMC.2356bc9c.svg";